'use client';

import { requestMarketingPopup } from '@apis/display/popup';
import { useWckQuery } from '@hooks/wckQuery/useWckQuery';
import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { PopupResopnse } from '@wconcept/wconcept-common/models/renewal/popup';

const MarketingPopupStateContext = createContext<{
  marketingPopup: PopupResopnse | undefined;
}>({
  marketingPopup: undefined,
});

export function MarketingPopupStateProvider({ children }: PropsWithChildren) {
  const { data } = useWckQuery({
    queryKey: ['marketingPopupState'],
    queryFn: () => requestMarketingPopup(),
    gcTime: 0,
    staleTime: 0,
  });
  const marketingPopup = useMemo(() => ({ marketingPopup: data }), [data]);
  return (
    <MarketingPopupStateContext.Provider value={marketingPopup}>
      {children}
    </MarketingPopupStateContext.Provider>
  );
}

export const useMarketingPopupState = () => {
  const { marketingPopup } = useContext(MarketingPopupStateContext);
  return { marketingPopup };
};
